import Section from '@app/components/atoms/Section/Section'
import useRemember from '@app/libs/useRemember'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Grid from '@mui/material/Grid'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

const Title = styled(Typography)`
  margin-bottom: 20px;
`

const Expand = styled(IconButton)(({ theme }) => {
  return {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }
})

const Setting = ({ partner }) => {
  const { t } = useTranslation()

  const [expandedLogo, setExpandedLogo] = useRemember('SettingLogo', true)

  const handleExpandClickLogo = () => {
    setExpandedLogo(!expandedLogo)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Section>
          <Grid item xs={8}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Title variant="h5">{t('PARTNER.PORTAL_INFO')}</Title>
              </Grid>
              <Grid item xs={3}>
                <Typography color="textSecondary">{t('PARTNER.TITLE')}</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>{partner.web_title}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography color="textSecondary">{t('PARTNER.LOYALTY_UNIT')}*</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>{partner.loyalty_unit}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography color="textSecondary">{t('PARTNER.HOME_PAGE')}</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>{partner.home_page_link}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section>
          <Grid item xs={8}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5">
                  {t('CAMPAIGN.IMAGES')}{' '}
                  <Expand aria-expanded={expandedLogo} aria-label="show more" onClick={handleExpandClickLogo}>
                    <ExpandMoreIcon />
                  </Expand>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Collapse unmountOnExit in={expandedLogo} timeout="auto">
                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      <Typography color="textSecondary">{t('PARTNER.LOGO')}</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <img src={partner.logo.link} width={300} />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      <Typography color="textSecondary">{t('PARTNER.FAVICON')}</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <img src={partner.favicon.link} width={100} />
                    </Grid>
                  </Grid>
                </Collapse>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>
    </Grid>
  )
}

export default Setting
